import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import flowMixin from '@/mixins/flowMixins'
import complements from '@/rahmen/complement'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import date from '@/ddv2.library/date'
import d2fmt from '@/ddv2.library/utils/formatter'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
// import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdJitsuUnsoTaiseiKanriEdit from '@/components/DdJitsuUnsoTaiseiKanriEdit'

const DdCalcDistance = () => import('@/components/DdCalcDistance.vue')
const DdCalcTankaButton = () => import('@/components/DdCalcTankaButton.vue')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdIconButton = () => import('@/components/DdIconButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdPackageTeikeiCourseSearchTextBox = () => import('@/components/DdPackageTeikeiCourseSearchTextBox')

export default {
  name: 'JuchuEditSimple',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCalcDistance,
    DdCalcTankaButton,
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdIconButton,
    DdIconButtonWithTooltip,
    DdJitsuUnsoTaiseiKanriEdit,
    DdNumericBox,
    DdSubHeader,
    DdTimeBoxSwitching,
    DdTextBox,
    DdTextBoxSwitching,
    DdPackageTeikeiCourseSearchTextBox
  },
  data: () => ({
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    recHaisoMeisai: {},

    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    baseYmd: '',
    mapData: [],

    readOnlyMode: false,
    modeKengen: 2, // 0:読み取り専用,1:削除不可,2:フルアクセス
    modeOfEdit: 0,

    recTokuisakiInfo: {},
    hinmeiSwitch: false,
    hatsuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiSwitch: false,
    chakuchiHmsSwitch: false,
    expandKeiyuchi: false,

    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders

  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      teikeiCourseList: 'DDMasters/vwCD2mstd0460',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // ----------------------------------------------------------------------------------------------------
    // マスタヘルプフィルタ
    // ----------------------------------------------------------------------------------------------------
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 得意先
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 品名
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredTeikeiCourseList () {
      return this.teikeiCourseList.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiCd + ' : ' + elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        elem.keiyuchiId2Disp = elem.keiyuchiId2 ? elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm : elem.keiyuchiId2Biko
        elem.keiyuchiId3Disp = elem.keiyuchiId3 ? elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm : elem.keiyuchiId3Biko
        elem.keiyuchiId4Disp = elem.keiyuchiId4 ? elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm : elem.keiyuchiId4Biko
        elem.keiyuchiId5Disp = elem.keiyuchiId5 ? elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm : elem.keiyuchiId5Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        elem.yoteiSagyoJikanDisp = elem.yoteiSagyoJikan ? filter.minToIntervalTimeFormatter(elem.yoteiSagyoJikan) : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.hokanKingaku) { elem.hokanKingaku = filter.numericFormatter(elem.hokanKingaku) }
        if (elem.niekiKingaku) { elem.niekiKingaku = filter.numericFormatter(elem.niekiKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.tatekaekinHikazei) { elem.tatekaekinHikazei = filter.numericFormatter(elem.tatekaekinHikazei) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        elem.warimashiTaishoJikanDisp = elem.warimashiTaishoJikan ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : null
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) }
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) + ' km' : null
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.sagyoinTeateKingaku1) { elem.sagyoinTeateKingaku1 = filter.numericFormatter(elem.sagyoinTeateKingaku1) }
        if (elem.sharyoKeihiHiwayEtc) { elem.sharyoKeihiHiwayEtc = filter.numericFormatter(elem.sharyoKeihiHiwayEtc) }
        if (elem.sharyoKeihiHiwayGenkin) { elem.sharyoKeihiHiwayGenkin = filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) }
        if (elem.sharyoKeihiFerry) { elem.sharyoKeihiFerry = filter.numericFormatter(elem.sharyoKeihiFerry) }
        return elem
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 区分種別フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 往復種別
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },

    // ----------------------------------------------------------------------------------------------------
    // 金額計算
    // ----------------------------------------------------------------------------------------------------
    calcSeikyuKingakuAmount () {
      let amount = 0

      if (this.hikazeiKingakuAmount > 0 || this.unchinAddWarimashiKingakuAmout > 0) {
        amount = parseInt(this.hikazeiKingakuAmount, 10) + parseInt(this.unchinAddWarimashiKingakuAmout, 10)
      }

      return amount
    },
    calcUnchin () {
      let amount = 0

      let tanka = this.recHaisoMeisai.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }

      if (this.recHaisoMeisai.unchinKeisanKbn === '01') {
        let juchuSuryo = this.recHaisoMeisai.juchuSuryo
        if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
      } else if (this.recHaisoMeisai.unchinKeisanKbn === '02') {
        let juchuJuryo = this.recHaisoMeisai.juchuJuryo
        if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
      } else if (this.recHaisoMeisai.unchinKeisanKbn === '03') {
        amount = parseFloat(tanka, 10)
      }
      amount = this.calcFraction(amount)
      return amount
    },
    unchinKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let hokanKingaku = this.recHaisoMeisai.hokanKingaku
      let niekiKingaku = this.recHaisoMeisai.niekiKingaku
      let unchinHokaKingaku = this.recHaisoMeisai.unchinHokaKingaku
      let nenryoSurcharge = this.recHaisoMeisai.nenryoSurcharge
      let tsumikomiKingaku = this.recHaisoMeisai.tsumikomiKingaku
      let torioroshiKingaku = this.recHaisoMeisai.torioroshiKingaku
      let taikiJikanKingaku = this.recHaisoMeisai.taikiJikanKingaku

      if (hokanKingaku === undefined || hokanKingaku === '' || hokanKingaku === null) { hokanKingaku = '0' }
      if (niekiKingaku === undefined || niekiKingaku === '' || niekiKingaku === null) { niekiKingaku = '0' }
      if (unchinHokaKingaku === undefined || unchinHokaKingaku === '' || unchinHokaKingaku === null) { unchinHokaKingaku = '0' }
      if (nenryoSurcharge === undefined || nenryoSurcharge === '' || nenryoSurcharge === null) { nenryoSurcharge = '0' }
      if (tsumikomiKingaku === undefined || tsumikomiKingaku === '' || tsumikomiKingaku === null) { tsumikomiKingaku = '0' }
      if (torioroshiKingaku === undefined || torioroshiKingaku === '' || torioroshiKingaku === null) { torioroshiKingaku = '0' }
      if (taikiJikanKingaku === undefined || taikiJikanKingaku === '' || taikiJikanKingaku === null) { taikiJikanKingaku = '0' }

      let amount = 0

      amount = parseInt(this.calcUnchin, 10) +
                parseInt(hokanKingaku, 10) +
                parseInt(niekiKingaku, 10) +
                parseInt(unchinHokaKingaku, 10) +
                parseInt(nenryoSurcharge, 10) +
                parseInt(tsumikomiKingaku, 10) +
                parseInt(torioroshiKingaku, 10) +
                parseInt(taikiJikanKingaku, 10)

      return amount
    },
    futaiGyomuKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let futaiGyomuKingaku1 = this.recHaisoMeisai.futaiGyomuKingaku1
      let futaiGyomuKingaku2 = this.recHaisoMeisai.futaiGyomuKingaku2
      let futaiGyomuKingaku3 = this.recHaisoMeisai.futaiGyomuKingaku3
      let futaiGyomuKingaku4 = this.recHaisoMeisai.futaiGyomuKingaku4
      let futaiGyomuKingaku5 = this.recHaisoMeisai.futaiGyomuKingaku5
      let futaiGyomuKingaku6 = this.recHaisoMeisai.futaiGyomuKingaku6
      let futaiGyomuKingaku7 = this.recHaisoMeisai.futaiGyomuKingaku7
      let futaiGyomuKingaku8 = this.recHaisoMeisai.futaiGyomuKingaku8
      let futaiGyomuKingaku9 = this.recHaisoMeisai.futaiGyomuKingaku9
      let futaiGyomuKingaku10 = this.recHaisoMeisai.futaiGyomuKingaku10
      let futaiGyomuKingaku = this.recHaisoMeisai.futaiGyomuKingaku

      if (futaiGyomuKingaku1 === undefined || futaiGyomuKingaku1 === '' || futaiGyomuKingaku1 === null) { futaiGyomuKingaku1 = '0' }
      if (futaiGyomuKingaku2 === undefined || futaiGyomuKingaku2 === '' || futaiGyomuKingaku2 === null) { futaiGyomuKingaku2 = '0' }
      if (futaiGyomuKingaku3 === undefined || futaiGyomuKingaku3 === '' || futaiGyomuKingaku3 === null) { futaiGyomuKingaku3 = '0' }
      if (futaiGyomuKingaku4 === undefined || futaiGyomuKingaku4 === '' || futaiGyomuKingaku4 === null) { futaiGyomuKingaku4 = '0' }
      if (futaiGyomuKingaku5 === undefined || futaiGyomuKingaku5 === '' || futaiGyomuKingaku5 === null) { futaiGyomuKingaku5 = '0' }
      if (futaiGyomuKingaku6 === undefined || futaiGyomuKingaku6 === '' || futaiGyomuKingaku6 === null) { futaiGyomuKingaku6 = '0' }
      if (futaiGyomuKingaku7 === undefined || futaiGyomuKingaku7 === '' || futaiGyomuKingaku7 === null) { futaiGyomuKingaku7 = '0' }
      if (futaiGyomuKingaku8 === undefined || futaiGyomuKingaku8 === '' || futaiGyomuKingaku8 === null) { futaiGyomuKingaku8 = '0' }
      if (futaiGyomuKingaku9 === undefined || futaiGyomuKingaku9 === '' || futaiGyomuKingaku9 === null) { futaiGyomuKingaku9 = '0' }
      if (futaiGyomuKingaku10 === undefined || futaiGyomuKingaku10 === '' || futaiGyomuKingaku10 === null) { futaiGyomuKingaku10 = '0' }
      if (futaiGyomuKingaku === undefined || futaiGyomuKingaku === '' || futaiGyomuKingaku === null) { futaiGyomuKingaku = '0' }

      let amount = 0

      amount = parseInt(futaiGyomuKingaku1, 10) +
                parseInt(futaiGyomuKingaku2, 10) +
                parseInt(futaiGyomuKingaku3, 10) +
                parseInt(futaiGyomuKingaku4, 10) +
                parseInt(futaiGyomuKingaku5, 10) +
                parseInt(futaiGyomuKingaku6, 10) +
                parseInt(futaiGyomuKingaku7, 10) +
                parseInt(futaiGyomuKingaku8, 10) +
                parseInt(futaiGyomuKingaku9, 10) +
                parseInt(futaiGyomuKingaku10, 10) +
                parseInt(futaiGyomuKingaku, 10)

      return amount
    },
    hikazeiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let hiwayPrice = this.recHaisoMeisai.hiwayPrice
      let unchinHokaHikazei = this.recHaisoMeisai.unchinHokaHikazei
      let tatekaekinHikazei = this.recHaisoMeisai.tatekaekinHikazei

      if (hiwayPrice === undefined || hiwayPrice === '' || hiwayPrice === null) { hiwayPrice = '0' }
      if (unchinHokaHikazei === undefined || unchinHokaHikazei === '' || unchinHokaHikazei === null) { unchinHokaHikazei = '0' }
      if (tatekaekinHikazei === undefined || tatekaekinHikazei === '' || tatekaekinHikazei === null) { tatekaekinHikazei = '0' }

      let amount = 0

      amount = parseInt(hiwayPrice, 10) + parseInt(unchinHokaHikazei, 10) + parseInt(tatekaekinHikazei, 10)

      return amount
    },
    warimashiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let jikanWarimashiKingaku = this.recHaisoMeisai.jikanWarimashiKingaku
      let kyoriWarimashiKingaku = this.recHaisoMeisai.kyoriWarimashiKingaku
      let warimashiSonotaKingsku = this.recHaisoMeisai.warimashiSonotaKingsku

      if (jikanWarimashiKingaku === undefined || jikanWarimashiKingaku === '' || jikanWarimashiKingaku === null) { jikanWarimashiKingaku = '0' }
      if (kyoriWarimashiKingaku === undefined || kyoriWarimashiKingaku === '' || kyoriWarimashiKingaku === null) { kyoriWarimashiKingaku = '0' }
      if (warimashiSonotaKingsku === undefined || warimashiSonotaKingsku === '' || warimashiSonotaKingsku === null) { warimashiSonotaKingsku = '0' }

      let amount = 0

      amount = parseInt(jikanWarimashiKingaku, 10) + parseInt(kyoriWarimashiKingaku, 10) + parseInt(warimashiSonotaKingsku, 10)

      return amount
    },
    unchinAddWarimashiKingakuAmout () {
      let amount = 0

      amount = parseInt(this.unchinKingakuAmount, 10) + parseInt(this.warimashiKingakuAmount, 10) + parseInt(this.futaiGyomuKingakuAmount, 10)

      return amount
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目制御
    // ----------------------------------------------------------------------------------------------------
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && !this.recHaisoMeisai.seikyuZumiFlg) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisp () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1 && !this.recHaisoMeisai.seikyuZumiFlg) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.recHaisoMeisai.seikyuZumiFlg || this.readOnlyMode) {
        return true
      }
      return false
    },
    isMapUsable () {
      if ((this.recHaisoMeisai.hatsuchiId) ||
          (this.recHaisoMeisai.keiyuchiId1) ||
          (this.recHaisoMeisai.keiyuchiId2) ||
          (this.recHaisoMeisai.keiyuchiId3) ||
          (this.recHaisoMeisai.keiyuchiId4) ||
          (this.recHaisoMeisai.keiyuchiId5) ||
          (this.recHaisoMeisai.chakuchiId)) {
        return true
      }
      return false
    }
  },

  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },

  mounted () {
    this.initialize()
  },

  methods: {
    getCloneTargetMethod: function () {
      return {
        recHaisoMeisai: this.recHaisoMeisai
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // データ抽出処理
    // ----------------------------------------------------------------------------------------------------
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        // /* eslint no-debugger: "warn" */
        // debugger

        this.HttpClient
          .get(`/api/v1/VwCD2prmd0020/Find?id=${this.id}`)
          .then((data) => {
            if (data.payload) {
              const x = data.payload

              if (x.juchuYmd) {
                x.juchuYmd = filter.dateFormatter(x.juchuYmd)
              }
              if (x.sagyoYoteiYmd) {
                x.sagyoYoteiYmd = filter.dateFormatter(x.sagyoYoteiYmd)
              }
              if (x.hatsuchiYmd) {
                x.hatsuchiYmd = filter.dateFormatter(x.hatsuchiYmd)
              }
              if (x.hatsuchiHms) {
                x.hatsuchiHms = complements.parseTime(x.hatsuchiHms, false).substr(0, 5)
              }
              if (x.chakuchiYmd) {
                x.chakuchiYmd = filter.dateFormatter(x.chakuchiYmd)
              }
              if (x.chakuchiHms) {
                x.chakuchiHms = complements.parseTime(x.chakuchiHms, false).substr(0, 5)
              }
              if (x.seikyuYoteiYmd) {
                x.seikyuYoteiYmd = filter.dateFormatter(x.seikyuYoteiYmd)
              }
              if (x.yoteiSagyoJikan != null) {
                x.yoteiSagyoJikan = filter.minToIntervalTimeFormatter(x.yoteiSagyoJikan)
              }
              if (x.taikiJikan != null) {
                x.taikiJikan = filter.minToIntervalTimeFormatter(x.taikiJikan)
              }
              if (x.warimashiTaishoJikan != null) {
                x.warimashiTaishoJikan = filter.minToIntervalTimeFormatter(x.warimashiTaishoJikan)
              }
              if (x.motoukeHokokuYmd) {
                x.motoukeHokokuYmd = filter.dateFormatter(x.motoukeHokokuYmd)
              }
              x.thkId = null
              x.thmId = null

              this.recHaisoMeisai = x

              if (this.recHaisoMeisai.seikyuZumiFlg) {
                this.setInvalidSummaryMessage('RCOI0006')
              }

              // 基準日設定
              this.baseYmd = filter.dateFormatter(this.recHaisoMeisai.juchuYmd)

              // クローン情報設定
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            }
          })
        resolve()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期化処理
    // ----------------------------------------------------------------------------------------------------
    initialize () {
      const self = this
      const option = {
        loadMasters: [
          'msttorihikisaki',
          'msteigyosho',
          'msthinmei',
          'msthacchakuchi',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          'msyskubun',
          'mstshubetsu',
          'vwcd2mstd0460'
        ],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        existsIdMethod: function () {
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            // 権限制御
            if (kengen.kengenKbn === '10') {
              self.modeKengen = 0 // 読取モード
            } else if (kengen.kengenKbn === '20') {
              self.modeKengen = 1 // 削除不可モード
            } else {
              self.modeKengen = 2 // フルアクセス
            }

            // 画面モード設定
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForRegister(option)
    },

    // 反映ボタン押下時
    teikeiCourseNoSync: function () {
      if (!this.recHaisoMeisai.teikeiKihonNo) { return }
      var teikeiInfo = this.getTeikeiInfo(this.recHaisoMeisai.teikeiKihonNo)
      this.teikeiCourseNoDialogSync(teikeiInfo)
    },
    // ポップアップから選択時
    teikeiCourseNoDialogSync: function (elem) {
      var initHaisoMeisai = Object.assign({}, this.recHaisoMeisai)

      initHaisoMeisai = {
        ...initHaisoMeisai,
        teikeiKihonNo: elem.teikeiKihonNo,
        // juchuEigyoshoId: elem.tantoEigyoshoId,
        ohfukuSbt: elem.ohfukuSbt,
        chumonNo: elem.chumonNo,
        tokuisakiId: elem.tokuisakiId,
        mstHinmeiId: elem.mstHinmeiId,
        hinmeiBiko: elem.hinmeiBiko,
        hatsuchiId: elem.hatsuchiId,
        hatsuchiBiko: elem.hatsuchiBiko,
        hatsuchiHms: elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : null,
        hatsuchiHmsBiko: elem.hatsuchiHmsBiko,
        keiyuchiId1: elem.keiyuchiId1,
        keiyuchiBiko1: elem.keiyuchiId1Biko,
        keiyuchiId2: elem.keiyuchiId2,
        keiyuchiBiko2: elem.keiyuchiId2Biko,
        keiyuchiId3: elem.keiyuchiId3,
        keiyuchiBiko3: elem.keiyuchiId3Biko,
        keiyuchiId4: elem.keiyuchiId4,
        keiyuchiBiko4: elem.keiyuchiId4Biko,
        keiyuchiId5: elem.keiyuchiId5,
        keiyuchiBiko5: elem.keiyuchiId5Biko,
        chakuchiId: elem.chakuchiId,
        chakuchiBiko: elem.chakuchiBiko,
        chakuchiHms: elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : null,
        chakuchiHmsBiko: elem.chakuchiHmsBiko,
        unchinKeisanKbn: elem.unchinKeisanKbn,
        seikyuShashuSbt: elem.seikyuShashuSbt,
        yoteiSokoKyori: d2fmt.removeComma(elem.yoteiSokoKyori),
        yoteiSagyoJikan: elem.yoteiSagyoJikanDisp,
        juchuSuryo: d2fmt.removeComma(elem.juchuSuryo),
        unitKbn: elem.unitKbn,
        juchuJuryo: d2fmt.removeComma(elem.juchuJuryo),
        tanka: d2fmt.removeComma(elem.tanka),
        hiwayPrice: d2fmt.removeComma(elem.hiwayPrice),
        unchinHokaKingaku: d2fmt.removeComma(elem.unchinHokaKingaku),
        hokanKingaku: d2fmt.removeComma(elem.hokanKingaku),
        niekiKingaku: d2fmt.removeComma(elem.niekiKingaku),
        unchinHokaHikazei: d2fmt.removeComma(elem.unchinHokaHikazei),
        tatekaekinHikazei: d2fmt.removeComma(elem.tatekaekinHikazei),
        nenryoSurcharge: d2fmt.removeComma(elem.nenryoSurcharge),
        tsumikomiKingaku: d2fmt.removeComma(elem.tsumikomiKingaku),
        torioroshiKingaku: d2fmt.removeComma(elem.torioroshiKingaku),
        taikiJikan: elem.taikiJikanDisp,
        taikiJikanTanka: d2fmt.removeComma(elem.taikiJikanTanka),
        taikiJikanKingaku: d2fmt.removeComma(elem.taikiJikanKingaku),
        futaiGyomuKingaku: d2fmt.removeComma(elem.futaiGyomuKingaku),
        warimashiTaishoJikan: elem.warimashiTaishoJikanDisp,
        warimashiJikanTanka: d2fmt.removeComma(elem.warimashiJikanTanka),
        warimashiTaishoKyori: d2fmt.removeComma(elem.warimashiTaishoKyori),
        warimashiKyoriTanka: d2fmt.removeComma(elem.warimashiKyoriTanka),
        warimashiSonotaKingsku: d2fmt.removeComma(elem.warimashiSonotaKingaku),
        sagyoinTeateKingaku1: d2fmt.removeComma(elem.sagyoinTeateKingaku1),
        sharyoKeihiHiwayEtc: d2fmt.removeComma(elem.sharyoKeihiHiwayEtc),
        sharyoKeihiHiwayGenkin: d2fmt.removeComma(elem.sharyoKeihiHiwayGenkin),
        sharyoKeihiFerry: d2fmt.removeComma(elem.sharyoKeihiFerry),
        seikyuBiko: elem.seikyuBiko,
        renrakuBiko: elem.renrakuBiko
      }
      this.hinmeiSwitch = Boolean(!initHaisoMeisai.mstHinmeiId && initHaisoMeisai.hinmeiBiko)
      this.hatsuchiSwitch = Boolean(!initHaisoMeisai.hatsuchiId && initHaisoMeisai.hatsuchiBiko)
      this.hatsuchiHmsSwitch = Boolean(!initHaisoMeisai.hatsuchiHms && initHaisoMeisai.hatsuchiHmsBiko)
      this.chakuchiSwitch = Boolean(!initHaisoMeisai.chakuchiId && initHaisoMeisai.chakuchiBiko)
      this.chakuchiHmsSwitch = Boolean(!initHaisoMeisai.chakuchiHms && initHaisoMeisai.chakuchiHmsBiko)
      this.expandKeiyuchi = Boolean(initHaisoMeisai.keiyuchiId2 || initHaisoMeisai.keiyuchiBiko2 || initHaisoMeisai.keiyuchiId3 || initHaisoMeisai.keiyuchiBiko3 || initHaisoMeisai.keiyuchiId4 || initHaisoMeisai.keiyuchiBiko4 || initHaisoMeisai.keiyuchiId5 || initHaisoMeisai.keiyuchiBiko5)

      if (initHaisoMeisai.hatsuchiYmd && initHaisoMeisai.hatsuchiHms && initHaisoMeisai.chakuchiHms && (initHaisoMeisai.hatsuchiYmd >= initHaisoMeisai.chakuchiYmd || !initHaisoMeisai.chakuchiYmd) && initHaisoMeisai.hatsuchiHms > initHaisoMeisai.chakuchiHms) {
        initHaisoMeisai.chakuchiYmd = filter.dateFormatter(dayjs(initHaisoMeisai.hatsuchiYmd).add(1, 'd'))
      }
      this.recHaisoMeisai = Object.assign({}, initHaisoMeisai)
      this.calcJikanWarimashiKingaku()
      this.calcKyoriWarimashiKingaku()
      initHaisoMeisai = undefined
    },

    onCourseRirekiClick: function () {
      this.$refs.teikeiKihonNo.onDialogButtonClick()
    },

    // ----------------------------------------------------------------------------------------------------
    // 戻るボタン押下
    // ----------------------------------------------------------------------------------------------------
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // キャンセルボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.recHaisoMeisai = self.cloneData.recHaisoMeisai
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // 削除ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.convertToDBType()
            self.HttpClient.post('/api/v1/VwCD2prmd0020/DeleteJuchuInfo', self.recHaisoMeisai).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },

    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyButtonClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        const x = this.recHaisoMeisai
        x.id = -1
        x.tjmId = null
        x.tjhId = null
        x.tjkKinId = null
        x.tjmKinId = null
        x.tjhKinId = null
        x.tjrKihonId = null
        x.tjrMeisaiId = null
        x.tsmId = null
        x.tskMeisaiId = null
        x.tshId = null
        x.tskHinmokuId = null
        x.thkId = null
        x.thmId = null
        x.thkKinId = null
        x.thmKinId = null
        x.juchuNo = null
        x.meisaiOrder = null
        x.seikyuZumiFlg = false

        this.recHaisoMeisai = x
        this.modeOfEdit = 0
        this.Effects.loadComplete()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 保存ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            self.fetchData()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2prmd0020/CreateJuchuInfo', this.recHaisoMeisai)
      return f
    },
    registerValidate: function () {
      return true
    },
    convertToDBType: function () {
      if (this.recHaisoMeisai.taikiJikan) {
        this.recHaisoMeisai.taikiJikan = filter.timeToMinFormatter(this.recHaisoMeisai.taikiJikan)
      }
      if (this.recHaisoMeisai.yoteiSagyoJikan) {
        this.recHaisoMeisai.yoteiSagyoJikan = filter.timeToMinFormatter(this.recHaisoMeisai.yoteiSagyoJikan)
      }
      if (this.recHaisoMeisai.warimashiTaishoJikan) {
        this.recHaisoMeisai.warimashiTaishoJikan = filter.timeToMinFormatter(this.recHaisoMeisai.warimashiTaishoJikan)
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // GoogleMapリンク
    // ----------------------------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiId) || ![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiBiko)) {
        const hatsuchi = {
          id: this.recHaisoMeisai.hatsuchiId,
          biko: this.recHaisoMeisai.hatsuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }
      // 経由地１ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko1)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId1,
          biko: this.recHaisoMeisai.keiyuchiBiko1,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地２ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko2)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId2,
          biko: this.recHaisoMeisai.keiyuchiBiko2,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地３ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko3)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId3,
          biko: this.recHaisoMeisai.keiyuchiBiko3,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地４ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId4) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko4)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId4,
          biko: this.recHaisoMeisai.keiyuchiBiko4,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地５ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId5) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko5)) {
        const keiyuchi = {
          id: this.recHaisoMeisai.keiyuchiId5,
          biko: this.recHaisoMeisai.keiyuchiBiko5,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd) ? this.recHaisoMeisai.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiHms) ? this.recHaisoMeisai.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 着地設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiId) || ![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiBiko)) {
        const chakuchi = {
          id: this.recHaisoMeisai.chakuchiId,
          biko: this.recHaisoMeisai.chakuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiYmd) ? this.recHaisoMeisai.chakuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiHms) ? this.recHaisoMeisai.chakuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },

    // --------------------------------------------------------------------------------
    // 発着経由地入れ替え
    // --------------------------------------------------------------------------------
    onHatsuChakuReplace: function () {
      var tempHatsuChakuInfo = {
        hatsuchiId: this.recHaisoMeisai.hatsuchiId,
        hatsuchiBiko: this.recHaisoMeisai.hatsuchiBiko,
        keiyuchiId1: this.recHaisoMeisai.keiyuchiId1,
        keiyuchiBiko1: this.recHaisoMeisai.keiyuchiBiko1,
        keiyuchiId2: this.recHaisoMeisai.keiyuchiId2,
        keiyuchiBiko2: this.recHaisoMeisai.keiyuchiBiko2,
        keiyuchiId3: this.recHaisoMeisai.keiyuchiId3,
        keiyuchiBiko3: this.recHaisoMeisai.keiyuchiBiko3,
        keiyuchiId4: this.recHaisoMeisai.keiyuchiId4,
        keiyuchiBiko4: this.recHaisoMeisai.keiyuchiBiko4,
        keiyuchiId5: this.recHaisoMeisai.keiyuchiId5,
        keiyuchiBiko5: this.recHaisoMeisai.keiyuchiBiko5,
        chakuchiId: this.recHaisoMeisai.chakuchiId,
        chakuchiBiko: this.recHaisoMeisai.chakuchiBiko
      }

      // 既存値初期化
      this.recHaisoMeisai.hatsuchiId = null
      this.recHaisoMeisai.hatsuchiBiko = null
      this.recHaisoMeisai.keiyuchiId1 = null
      this.recHaisoMeisai.keiyuchiBiko1 = null
      this.recHaisoMeisai.keiyuchiId2 = null
      this.recHaisoMeisai.keiyuchiBiko2 = null
      this.recHaisoMeisai.keiyuchiId3 = null
      this.recHaisoMeisai.keiyuchiBiko3 = null
      this.recHaisoMeisai.keiyuchiId4 = null
      this.recHaisoMeisai.keiyuchiBiko4 = null
      this.recHaisoMeisai.keiyuchiId5 = null
      this.recHaisoMeisai.keiyuchiBiko5 = null
      this.recHaisoMeisai.chakuchiId = null
      this.recHaisoMeisai.chakuchiBiko = null

      if (![undefined, null, ''].includes(tempHatsuChakuInfo.chakuchiId)) {
        this.recHaisoMeisai.hatsuchiId = tempHatsuChakuInfo.chakuchiId
        this.recHaisoMeisai.hatsuchiBiko = tempHatsuChakuInfo.chakuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.hatsuchiId)) {
        this.recHaisoMeisai.chakuchiId = tempHatsuChakuInfo.hatsuchiId
        this.recHaisoMeisai.chakuchiBiko = tempHatsuChakuInfo.hatsuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId5)) {
        this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId5
        this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko5
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId4)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId4
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko4
        } else {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId4
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko4
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId3)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko3
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko3
        } else {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko3
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId2)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3)) {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko2
        } else {
          this.recHaisoMeisai.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko2
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId1)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3)) {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId4)) {
          this.recHaisoMeisai.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko1
        } else {
          this.recHaisoMeisai.keiyuchiId5 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko5 = tempHatsuChakuInfo.keiyuchiBiko1
        }
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期値設定
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.baseYmd = date.getCurrentDate()
      // 入力項目
      this.$set(this.recHaisoMeisai, 'juchuYmd', this.baseYmd)
      this.recHaisoMeisai.juchuEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, this.baseYmd).id : null
      this.$set(this.recHaisoMeisai, 'sagyoYoteiYmd', this.baseYmd)
      this.recHaisoMeisai.sagyoEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, this.baseYmd).id : null
      this.$set(this.recHaisoMeisai, 'seikyuYoteiYmd', this.baseYmd)
      this.recHaisoMeisai.motoukeFlg = true

      // ドロップダウン
      this.$set(this.recHaisoMeisai, 'ohfukuSbt', null)
      this.$set(this.recHaisoMeisai, 'unitKbn', null)
      this.$set(this.recHaisoMeisai, 'unchinKeisanKbn', null)
      this.$set(this.recHaisoMeisai, 'seikyuShashuSbt', null)

      // 入力制御
      this.modeKengen = 0
      this.modeOfEdit = 0
      this.hinmeiSwitch = false
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
      this.expandKeiyuchi = false
    },

    // ----------------------------------------------------------------------------------------------------
    // 金額項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 得意先IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeTokuisaki: function () {
      if (!this.recHaisoMeisai.tokuisakiId) { return }
      console.log('changeTokuisakiId')
      this.recHaisoMeisai.torihikisakiCd = indexeddb.getRecord(this.torihikisakiList, this.recHaisoMeisai.tokuisakiId).torihikisakiCd
      if ([undefined, null, ''].includes(this.recHaisoMeisai.maninushiNm) && this.recHaisoMeisai.motoukeFlg) {
        this.recHaisoMeisai.maninushiNm = indexeddb.getRecord(this.torihikisakiList, this.recHaisoMeisai.tokuisakiId).torihikisakiNm
      }
      this.getTokuisakiInfo(this.recHaisoMeisai.tokuisakiId)
    },
    getTokuisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/D2PRMD0020/TokuisakiInfoFind?id=${this.recHaisoMeisai.tokuisakiId}`)
          .then((data) => {
            this.recTokuisakiInfo = data.payload
            console.log('getTokuisakiInfo', this.recTokuisakiInfo)
            this.initSeikyuYoteiYmd()
            if (!this.recHaisoMeisai.unchinKeisanKbn && this.recTokuisakiInfo.unchinKeisanKbn) {
              this.$set(this.recHaisoMeisai, 'unchinKeisanKbn', this.recTokuisakiInfo.unchinKeisanKbn)
            }
            this.recHaisoMeisai.warimashiJikanTanka = this.recHaisoMeisai.warimashiJikanTanka ? this.recHaisoMeisai.warimashiJikanTanka : this.recTokuisakiInfo.warimashiJikanTanka
            this.recHaisoMeisai.warimashiKyoriTanka = this.recHaisoMeisai.warimashiKyoriTanka ? this.recHaisoMeisai.warimashiKyoriTanka : this.recTokuisakiInfo.warimashiKyoriTanka
            this.calcJikanWarimashiKingaku()
            this.calcKyoriWarimashiKingaku()
          })
        resolve()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 請求予定日初期値設定
    // ----------------------------------------------------------------------------------------------------
    initSeikyuYoteiYmd: function () {
      const keijobiKbn = this.recTokuisakiInfo.keijobiKbn

      if (keijobiKbn === undefined || keijobiKbn === null || keijobiKbn === '') { return }

      if (this.recHaisoMeisai.seikyuYoteiYmd !== filter.dateFormatter(new Date()) && !this.recHaisoMeisai.meisaiOrder) { return }

      if (this.recHaisoMeisai.seikyuYoteiYmd && this.recHaisoMeisai.meisaiOrder) { return }

      if (keijobiKbn === '1' && this.recHaisoMeisai.hatsuchiYmd !== null && this.recHaisoMeisai.hatsuchiYmd !== '' && this.recHaisoMeisai.hatsuchiYmd !== undefined) {
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.recHaisoMeisai.hatsuchiYmd)
      } else if (keijobiKbn === '2' && this.recHaisoMeisai.chakuchiYmd !== null && this.recHaisoMeisai.chakuchiYmd !== '' && this.recHaisoMeisai.chakuchiYmd !== undefined) {
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.recHaisoMeisai.chakuchiYmd)
      }
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目切替
    // ----------------------------------------------------------------------------------------------------
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    },

    // ----------------------------------------------------------------------------------------------------
    // フィルタ補助
    // ----------------------------------------------------------------------------------------------------
    hacchakuchiFilter (elem) {
      const self = this
      const target = filter.dateFormatter(new Date())
      return (elem.tekiyoStartYmdDisp <= target) &&
            (elem.tekiyoEndYmdDisp >= target) &&
            (!self.selectNinushiCd || (elem.torihikisakiCd === self.selectNinushiCd || elem.torihikisakiCd === null))
    },

    // ----------------------------------------------------------------------------------------------------
    // 距離計算補助
    // ----------------------------------------------------------------------------------------------------
    setYoteiSokoKyori: function (e) {
      this.$set(this.recHaisoMeisai, 'yoteiSokoKyori', e.kyoriKm)
    },

    // ----------------------------------------------------------------------------------------------------
    // 時間計算補助
    // ----------------------------------------------------------------------------------------------------
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToTimeFormatter(min)
      }
      return result
    },

    // ----------------------------------------------------------------------------------------------------
    // 請求補助
    // ----------------------------------------------------------------------------------------------------
    inputTaikiJikan: function () {
      if (this.recHaisoMeisai.taikiJikan) {
        this.$set(this.recHaisoMeisai, 'taikiJikan', this.calcTime(String(this.recHaisoMeisai.taikiJikan)))
      }
    },
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.recHaisoMeisai.taikiJikan
      let taikiJikanTanka = this.recHaisoMeisai.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.recHaisoMeisai, 'taikiJikanKingaku', taikiJikanKingaku)
    },
    inputYoteiSagyoJikan: function () {
      if (this.recHaisoMeisai.yoteiSagyoJikan) {
        this.$set(this.recHaisoMeisai, 'yoteiSagyoJikan', this.calcTime(String(this.recHaisoMeisai.yoteiSagyoJikan)))
      }
    },
    setHachhakuchiTanka: function (e) {
      let temp = Object.assign({}, this.recHaisoMeisai)
      temp = {
        ...temp,
        /*
        juchuEigyoshoId: e.eigyoshoCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', e.eigyoshoCd, this.baseYmd).id : temp.juchuEigyoshoId,
        tokuisakiId: e.torihikisakiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.torihikisakiList, 'torihikisakiCd', e.torihikisakiCd, this.baseYmd).id : temp.tokuisakiId,
        mstHinmeiId: e.hinmeiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.hinmeiList, 'hinmeiCd', e.hinmeiCd, this.baseYmd).id : temp.mstHinmeiId,
        seikyuShashuSbt: e.unchinShashuSbt,
        */
        unchinKeisanKbn: e.unchinKeisanKbn,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        hokanKingaku: e.userKingakuKazei4,
        niekiKingaku: e.userKingakuKazei3,
        unchinHokaKingaku: e.userKingakuKazei1,
        unchinHokaHikazei: e.userKingakuHikazei1,
        tatekaekinHikazei: e.userKingakuHikazei2,
        warimashiSonotaKingsku: e.userKingakuKazei2
      }
      this.recHaisoMeisai = Object.assign({}, temp)
      temp = undefined
    },

    // ----------------------------------------------------------------------------------------------------
    // 割増補助
    // ----------------------------------------------------------------------------------------------------
    inputWarimashiTaishoJikan: function () {
      if (this.recHaisoMeisai.warimashiTaishoJikan) {
        this.$set(this.recHaisoMeisai, 'warimashiTaishoJikan', this.calcTime(String(this.recHaisoMeisai.warimashiTaishoJikan)))
      }
    },
    calcJikanWarimashiKingaku: function () {
      if (this.recHaisoMeisai.warimashiTaishoJikan && this.recHaisoMeisai.warimashiJikanTanka) {
        let warimashiTaishoJikan = this.recHaisoMeisai.warimashiTaishoJikan
        let warimashiJikanTanka = this.recHaisoMeisai.warimashiJikanTanka

        if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '') { warimashiTaishoJikan = 0 }
        if (warimashiJikanTanka === undefined || warimashiJikanTanka === '') { warimashiJikanTanka = 0 }

        warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)
        const jikanWarimashiKingaku = this.calcFraction((warimashiTaishoJikan / 60) * warimashiJikanTanka)
        this.$set(this.recHaisoMeisai, 'jikanWarimashiKingaku', jikanWarimashiKingaku)
      } else {
        this.$set(this.recHaisoMeisai, 'jikanWarimashiKingaku', null)
      }
    },
    calcKyoriWarimashiKingaku: function () {
      if (this.recHaisoMeisai.warimashiTaishoKyori && this.recHaisoMeisai.warimashiKyoriTanka) {
        let warimashiTaishoKyori = this.recHaisoMeisai.warimashiTaishoKyori
        let warimashiKyoriTanka = this.recHaisoMeisai.warimashiKyoriTanka

        if (warimashiTaishoKyori === undefined || warimashiTaishoKyori === '') { warimashiTaishoKyori = 0 }
        if (warimashiKyoriTanka === undefined || warimashiKyoriTanka === '') { warimashiKyoriTanka = 0 }

        const kyoriWarimashiKingaku = this.calcFraction(warimashiTaishoKyori * warimashiKyoriTanka)
        this.$set(this.recHaisoMeisai, 'kyoriWarimashiKingaku', kyoriWarimashiKingaku)
      } else {
        this.$set(this.recHaisoMeisai, 'kyoriWarimashiKingaku', null)
      }
    },
    calcFraction: function (x) {
      if ([undefined, null, ''].includes(this.recTokuisakiInfo) || [undefined, null, ''].includes(this.recTokuisakiInfo.unchinHasuKeisanKbn)) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    },
    // --------------------------------------------------
    // IndexedDB取得
    // --------------------------------------------------
    getTeikeiInfo: function (teikeiKihonNo) {
      var teikeiCourse = this.teikeiCourseList.find((t) => {
        return t.teikeiKihonNo === teikeiKihonNo
      })
      return teikeiCourse
    },
    setJuchuEigyosho: function () {
      if (this.recHaisoMeisai.juchuEigyoshoId) {
        this.recHaisoMeisai.juchuEigyoshoCd = indexeddb.getRecord(this.eigyoshoList, this.recHaisoMeisai.juchuEigyoshoId).eigyoshoCd
      }
    },
    setHinmei: function () {
      if (this.recHaisoMeisai.mstHinmeiId) {
        this.recHaisoMeisai.hinmeiCd = indexeddb.getRecord(this.hinmeiList, this.recHaisoMeisai.mstHinmeiId).hinmeiCd
      }
    },
    setHatsuchiId: function () {
      if (this.recHaisoMeisai.hatsuchiId) {
        this.recHaisoMeisai.hatsuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.recHaisoMeisai.hatsuchiId).hacchakuchiCd
      }
    },
    setChakuchiId: function () {
      if (this.recHaisoMeisai.chakuchiId) {
        this.recHaisoMeisai.chakuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.recHaisoMeisai.chakuchiId).hacchakuchiCd
      }
    }
  }
}
